Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.SurveyReorderQuestionTemplate = function () {
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'items': [
          {
            'items': [
              {
                'tag': 'input',
                'attributes': {
                  'type': 'button',
                  'class': 'btn i18nResource btn-secondary',
                  'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.cancelButton'),
                  'id': 'ReorderCancelButton',
                },
              },
              {
                'tag': 'input',
                'attributes': {
                  'type': 'button',
                  'class': 'btn i18nResource',
                  'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.saveButton'),
                  'id': 'ReorderSaveButton',
                  'style': 'float:right;',
                },
              },
              {
                'tag': 'div'
              }
            ],
            'attributes': {
              'class': 'buttonGroup standard-form-buttons',
            },
          },
          {
            'attributes': {
              'id': 'questionsToReorder',
              'class': 'questionContent',
            },
          },
        ],
        'attributes': {
          'class': 'formContent',
        },
      },
    ],
  }).render();
};
